import type { RouteObject } from 'react-router';

import { createPaths } from '@ricoh/ria.client.core/utils/router/path';

const infoRoute: RouteObject = {
  lazy: async () => (await import('~/components/layout/blank')).default,

  children: [
    // Privacy Policy
    {
      path: 'privacy-policy',
      lazy: async () => (await import('~/components/page/info/privacy-policy')).default,
    },

    // Cookie Policy
    {
      path: 'cookie-policy',
      lazy: async () => (await import('~/components/page/info/cookie-policy')).default,
    },

    // Imprint
    {
      path: 'imprint',
      lazy: async () => (await import('~/components/page/info/imprint')).default,
    },
  ],
};

/** Info paths. */
export const infoPaths = createPaths(infoRoute);

export default infoRoute;
